import { Controller } from "@hotwired/stimulus";

// Powers the "Visa bokning" lookup form (BookingController#show_booking) --
// shared by the standalone /visa_bokning page and the desktop modal (see
// booking/partials/_show_booking_form.html.erb, layouts/flygcity_responsive.html.erb).
// Same fetch-intercept-a-plain-form pattern as step2_submit_controller.js:
// on success the server returns the real booking page URL to navigate to;
// on failure it returns a message to show inline instead of the old
// popup_do fancybox dialog (dead on this Tailwind-rebuilt page).
export default class extends Controller {
  static targets = ["errorBanner", "submitButton", "submitSpinner"];

  async submit(event) {
    event.preventDefault();
    this.clearError();

    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true;
    if (this.hasSubmitSpinnerTarget) this.submitSpinnerTarget.classList.remove("hidden");

    const form = event.target;
    let response;
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json", ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}) },
        credentials: "same-origin",
      });
    } catch (e) {
      this.showError();
      return;
    }

    let data;
    try {
      data = await response.json();
    } catch (e) {
      this.showError();
      return;
    }

    if (data.status === "ok" && data.url) {
      window.location.href = data.url;
      return;
    }

    this.showError(data.message);
  }

  showError(message) {
    if (this.hasErrorBannerTarget) {
      this.errorBannerTarget.textContent = message || this.errorBannerTarget.dataset.genericError;
      this.errorBannerTarget.classList.remove("hidden");
    }
    this.resetSpinner();
  }

  clearError() {
    if (this.hasErrorBannerTarget) this.errorBannerTarget.classList.add("hidden");
  }

  resetSpinner() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false;
    if (this.hasSubmitSpinnerTarget) this.submitSpinnerTarget.classList.add("hidden");
  }
}
